import { useQuery } from '@apollo/client';

import { CanUseSecurityWithStrongAuthenticationDocument } from './graphql/canUseSecurityWithStrongAuthentication.gql';

export const useSecurityWithStrongAuthentication = () => {
  const { data } = useQuery(CanUseSecurityWithStrongAuthenticationDocument);

  return data?.canUseSecurityWithStrongAuthentication || false;
};
